<template>
  <div class="asWorkoutList">
    <slot />
  </div>
</template>

<style lang="scss">
  @import '@web/assets/scss/vars.scss';

  .asWorkoutList {
    min-height: 100px;
    /*overflow: auto;*/
    height: 100%;

    @media (max-width: $bp-desktop) {
      height: auto;
    }
    &:empty {
      display: none;
    }
  }
</style>
